import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth';
import axiosJWT from '@/services/api/axiosClient';
import { GET_IS_AUTH } from '@/constants/api/urls';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login_kd4J34s',
      name: 'Login',
      component: () => import('@/views/auth/LoginView.vue')
    },
    {
      path: '/dashboard',
      name: 'Dashboard',      
      component: () => import('@/views/dashboard/main/DashboardView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/dashboard/users',
      name: 'Users',
      component: () => import('@/views/dashboard/users/UsersView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/dashboard/transactions',
      name: 'Transactions',
      component: () => import('@/views/dashboard/transactions/TransactionsView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/dashboard/partners',
      name: 'Partners',
      component: () => import('@/views/dashboard/partners/PartnersView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/dashboard/support',
      name: 'Support',
      component: () => import('@/views/dashboard/support/SupportView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/dashboard/newsletters',
      name: 'Newsletters',
      component: () => import('@/views/dashboard/newsletters/NewsLetters.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/dashboard/settings',
      name: 'General',
      component: () => import('@/views/dashboard/settings/SettingsView.vue'),
      meta: { requiresAuth: true }
    },    
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/about/AboutView.vue')
    },
    {
      path: '/404',
      name: 'Not found',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/about/AboutView.vue')
    },
    { path: '/:catchAll(.*)', redirect: '/404' }
  ]
});

interface isAuthResponse {
  isAuth: boolean
}

router.beforeEach(async (to) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = to.meta.requiresAuth;
  const auth = useAuthStore();
  const jwtAuth = auth.getJwtAuth();

  try {

    if (authRequired) {
      
      if (!jwtAuth)
        return '/login_kd4J34s';

      const response = await axiosJWT.get(GET_IS_AUTH);
      const json: isAuthResponse = response.data;
//      console.log('json', json);
      if (!json.isAuth) {
        return '/login_kd4J34s';
      }

    }

  } catch (err) {
    console.log('err', err);
    return '/login_kd4J34s';
  }


});

export default router
